/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recover_Account_LabelInputs */



/**
* | output |
* | --- |
* | "Enter your email and we will send you a link to recover your account." |
*
* @param {Recover_Account_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const recover_account_label = /** @type {((inputs?: Recover_Account_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recover_Account_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Enter your email and we will send you a link to recover your account.")
	return /** @type {LocalizedString} */ ("Entrez votre adresse email et nous vous enverrons un lien pour récupérer votre compte.")
});